import { Stack } from '@mui/material';
import { DataGridPremium, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, useGridApiRef, useKeepGroupedColumnsHidden } from '@mui/x-data-grid-premium';
import * as React from 'react';
import FieldNames from '../../../defaults/FieldNames.json';
import { addCommas, currencyFormatter } from '../../../utils/FormatHelper';

export default function DataGridSummaries({isTreatment, isActual, isAll, chartData, label, features, keyToUse, isPrinting}) {
  const apiRef = useGridApiRef();
  const [rowGroupingModel, setRowGroupingModel] = React.useState(['deptVal', 'agencyVal', 'regionVal', 'unitVal']);

  let columns = [];

  let displayableFields = [];
  if(isAll){
    if(label === FieldNames.summaryOptionsFields.fundingAgency){
      displayableFields = [
        "fundDept",
        label,
        "numTreatments",
        "numActivities",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else if(label === FieldNames.summaryOptionsFields.fundingRegion){
      displayableFields = [
        "fundDept",
        "fundAgency",
        label,
        "numTreatments",
        "numActivities",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else if(label === FieldNames.summaryOptionsFields.fundingUnit){
      displayableFields = [
        "fundDept",
        "fundAgency",
        "fundRegion",
        label,
        "numTreatments",
        "numActivities",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else if(label === FieldNames.summaryOptionsFields.fundingSubUnit || label === FieldNames.summaryOptionsFields.fundingTribe){
      displayableFields = [
        "fundDept",
        "fundAgency",
        "fundRegion",
        "fundUnit",
        label,
        "numTreatments",
        "numActivities",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else {
      displayableFields = [
        label,
        "numTreatments",
        "numActivities",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    }
  } else {
    if(label === FieldNames.summaryOptionsFields.fundingAgency){
      displayableFields = [
        "fundDept",
        label,
        "number",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else if(label === FieldNames.summaryOptionsFields.fundingRegion){
      displayableFields = [
        "fundDept",
        "fundAgency",
        label,
        "number",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else if(label === FieldNames.summaryOptionsFields.fundingUnit){
      displayableFields = [
        "fundDept",
        "fundAgency",
        "fundRegion",
        label,
        "number",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else if(label === FieldNames.summaryOptionsFields.fundingSubUnit || label === FieldNames.summaryOptionsFields.fundingTribe){
      displayableFields = [
        "fundDept",
        "fundAgency",
        "fundRegion",
        "fundUnit",
        label,
        "number",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    } else {
      displayableFields = [
        label,
        "number",
        "allAcres",
        "acresPercent",
        "allTotalCosts",
        "costsPercent"
      ]
    }
  }
  

  if(displayableFields){
    displayableFields.forEach((element) => {
      if(element === "fundDept"){
        columns.push({
          field: "deptVal",
          headerName: FieldNames.summaryOptionsFields.fundingDepartment,
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: true,
          width: 200
        });
      } else if(element === "fundAgency"){
        columns.push({
          field: "agencyVal",
          headerName: FieldNames.summaryOptionsFields.fundingAgency,
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: true,
          width: 100
        });
      } else if(element === "fundRegion"){
        columns.push({
          field: "regionVal",
          headerName: FieldNames.summaryOptionsFields.fundingRegion,
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: true,
          width: 200
        });
      } else if(element === "fundUnit"){
        columns.push({
          field: "unitVal",
          headerName: FieldNames.summaryOptionsFields.fundingUnit,
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: true,
          width: 250
        });
      } else if(element === label){
        columns.push({
          field: "fieldVal",
          headerName: element,
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: false
        });
      } else if(element === "number"){
        let header = isTreatment ? "Number of Treatments" : "Number of Activities";
        if(FieldNames.summaryOptionsWithoutFields.includes(label)){
            header = isTreatment ? "Number of Treatment Lines of Funding" : "Number of Activity Lines of Funding";
        }
        columns.push({
          field: isTreatment ? "treatmentCounts" : "activityCounts",
          headerName: header,
          sortable: true,
          editable: false,
          aggregable: true,
          groupable: false,
          type: 'number'
        });
      } else if(element === "numTreatments") {
        let header = "Number of Treatments";
        if(FieldNames.summaryOptionsWithoutFields.includes(label)){
          header = "Number of Treatment Lines of Funding";
        }
        columns.push({
          field: "treatmentCounts",
          headerName: header,
          sortable: true,
          editable: false,
          aggregable: true,
          groupable: false,
          type: 'number',
          width: 200
        });
      } else if(element === "numActivities") {
        let header = "Number of Activities";
        if(FieldNames.summaryOptionsWithoutFields.includes(label)){
          header = "Number of Activity Lines of Funding";
        }
        columns.push({
          field: "activityCounts",
          headerName: header,
          sortable: true,
          editable: false,
          aggregable: true,
          groupable: false,
          type: 'number',
          width: 200
        });
      } else if(element === "acresPercent"){
        columns.push({
          field: "acresPercent",
          headerName: "% of Acres",
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: false,
          type: 'number',
          width: 150,
          valueFormatter: (value) => {
            if(value === 0){
              return '0%'
            } else {
              if(!value) {
                return '';
              } else {
                return value + "%";
              }
            }
          }
        });
      } else if(element === "allAcres"){
        columns.push({
          field: "acres",
          headerName: "Acres",
          sortable: true,
          editable: false,
          aggregable: true,
          groupable: false,
          type: 'number',
          width: 200,
          valueFormatter: (value) => {
            if(value === 0){
              return '0'
            } else {
              if(!value) {
                return '';
              } else {
                return addCommas(value);
              }
            }
          }
        });
      } else if(element === "totalCosts"){
        columns.push({
          field: "allTotals",
          headerName: "Total Costs",
          sortable: true,
          editable: false,
          aggregable: true,
          groupable: false,
          type: 'number',
          width: 200,
          valueFormatter: (value) => {
            if(value === 0){
              return '$0'
            } else {
              if(!value) {
                return '';
              } else {
                return currencyFormatter.format(value);
              }
            }
          }
        });
      } else if(element === "allTotalCosts"){
        columns.push({
          field: "totals",
          headerName: "Total Costs",
          sortable: true,
          editable: false,
          aggregable: true,
          groupable: false,
          type: 'number',
          width: 200,
          valueFormatter: (value) => {
            if(value === 0){
              return '$0'
            } else {
              if(!value) {
                return '';
              } else {
                return currencyFormatter.format(value);
              }
            }
          }
        });
      } else if(element === "costsPercent"){
        columns.push({
          field: "costsPercent",
          headerName: "% of Total Costs",
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: false,
          type: 'number',
          width: 200,
          valueFormatter: (value) => {
            if(value === 0){
              return '0%'
            } else {
              if(!value) {
                return '';
              } else {
                return value + "%";
              }
            }
          }
        });
      } else {
        columns.push({
          field: element,
          headerName: element,
          sortable: true,
          editable: false,
          aggregable: false,
          groupable: false,
          width: 150
        });
      }
    });
  }

  function CustomExportToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const initialState = useKeepGroupedColumnsHidden({
    apiRef,
    initialState: {
      density: "compact",
      aggregation: {
        model: {
          activityCounts: 'sum',
          treatmentCounts: 'sum',
          acres: 'sum',
          totals: 'sum',
        },
      },
      columns: {
        columnVisibilityModel: { 
          GroupingID: false,
          group: false,
          groupingName: false,
          deptVal: false,
          agencyVal: false,
          regionVal: false,
          unitVal: false
        }
      }
    },
  });

  return (
    <div style={{ height: isPrinting ? 'auto' : 600, width: '100%' }}>
        <h3 style={{ paddingLeft: 5 }}>{label}</h3>
        <DataGridPremium
          apiRef={apiRef}
          rows={features?.length ? features : []}
          getRowId={(row) => `${row?.internalId}-${row?.GroupingID}`}
          columns={columns}
          rowGroupingColumnMode="multiple"
          rowGroupingModel={rowGroupingModel}
          disableRowSelectionOnClick
          initialState={initialState}
          defaultGroupingExpansionDepth={-1}
          onRowGroupingModelChange={(model) => setRowGroupingModel(model)}
          groupingColDef={(params) => {
            return { hideDescendantCount: true }
          }}
          showToolbar
          slots={{
            toolbar: CustomExportToolbar,
            noRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                {"No Rows"}
              </Stack>
            )
          }}
          sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: "normal",
                paddingBottom: 2
              },
              "& .MuiDataGrid-columnHeader": {
                // Forced to use important since overriding inline styles
                height: "unset !important"
              },
              "& .MuiDataGrid-columnHeaders": {
                // Forced to use important since overriding inline styles
                maxHeight: "168px !important"
              }
          }}
        />
    </div>
  );
}